var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStorybook = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 800,
  height: 800,
  viewBox: "0 0 800 800",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M118.599 721.173 95.027 93.083c-.778-20.743 15.127-38.323 35.845-39.617l534.234-33.39c21.088-1.318 39.252 14.709 40.57 35.797.049.794.074 1.59.074 2.386v684.415c0 21.129-17.129 38.257-38.258 38.257-.572 0-1.144-.012-1.716-.038l-510.662-22.936c-19.889-.893-35.768-16.89-36.515-36.784Z",
  stroke: "currentColor",
  strokeWidth: 38
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m553.132 103.124 3.829-92.076L633.93 5l3.316 94.955a5.987 5.987 0 0 1-9.688 4.912l-29.682-23.382-35.143 26.658a5.988 5.988 0 0 1-9.601-5.019Zm-98.436 202.767c0 15.616 105.183 8.131 119.303-2.837 0-106.338-57.058-162.217-161.541-162.217-104.484 0-163.024 56.748-163.024 141.871 0 148.254 200.074 151.092 200.074 231.958 0 22.699-11.115 36.177-35.568 36.177-31.864 0-44.461-16.273-42.979-71.603 0-12.003-121.527-15.745-125.232 0-9.435 134.083 74.102 172.758 169.693 172.758 92.627 0 165.246-49.373 165.246-138.751 0-158.895-203.038-154.639-203.038-233.377 0-31.921 23.712-36.177 37.792-36.177 14.82 0 41.497 2.612 39.274 62.198Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStorybook);
export default ForwardRef;